import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const RefundApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRefunds: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        from: number;
        size: number;
        search: string;
        country?: string;
      }
    >({
      query: ({ from, size, search, country }) => {
        let url = END_POINTS.refund
        const paramArray = []
        if (from) {
          paramArray.push(`from=${from}`)
        }
        if (size) {
          paramArray.push(`size=${size}`)
        }
        if (search) {
          paramArray.push(`search=${search}`)
        }
        if (country) {
          paramArray.push(`country=${country}`)
        }
        if (paramArray.length) {
          url += `?${paramArray.join('&')}`
        }
        return ({
          url: url,
          method: "GET",
        })
      },
    }),
    updateRefund: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.updateRefund}`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetRefundsQuery,
  useUpdateRefundMutation
} = RefundApi;
